import { Link } from "react-router-dom";
import { Loader2, LogOut, ShieldCheck, ArrowRight } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useLang } from "../../i18n/LangContext";
import { AuthPanel, RolePicker } from "../auth/AuthPanel";
import { ClientDossier, ClientActivity } from "./ClientDossier";
import { ExpertProfile } from "./ExpertProfile";
import { ExpertMissions } from "./ExpertMissions";

export const SignedBar = ({ showSpaceLink }) => {
  const { user, signOut } = useAuth();
  const { t } = useLang();
  return (
    <div className="signed-bar" data-testid="signed-bar">
      <span className="f-note">{t.auth.signedAs} <b data-testid="signed-email">{user.email}</b>{user.role && <> · {t.adminX.roles[user.role]}</>}</span>
      <span style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {showSpaceLink && <Link to="/espace" className="btn btn-ghost btn-sm" data-testid="open-space-link">{t.auth.openSpace} <ArrowRight className="arrow" /></Link>}
        <button type="button" className="btn btn-ghost btn-sm" onClick={signOut} data-testid="pro-logout-btn"><LogOut aria-hidden="true" />{t.auth.logout}</button>
      </span>
    </div>
  );
};

const Message = ({ text, children }) => (
  <div className="panel pro-panel" data-testid="pro-gate-message"><p className="pro-intro" style={{ marginBottom: 16 }}>{text}</p>{children}</div>
);

const GateContent = ({ tab }) => {
  const { user } = useAuth();
  const { t } = useLang();
  if (!user.role) return <RolePicker />;
  if (user.role === "admin") {
    return <Message text={t.auth.adminHere}><Link to="/admin" className="btn btn-primary" data-testid="gate-open-admin-link"><ShieldCheck aria-hidden="true" />{t.auth.openAdmin}</Link></Message>;
  }
  if (tab === "timer") return user.role === "expert" ? <ExpertMissions /> : <ClientActivity showRequests={false} />;
  if (user.role !== tab) return <Message text={t.auth.wrongRole[tab]} />;
  return tab === "client" ? <ClientDossier /> : <ExpertProfile />;
};

export const ProGate = ({ tab, standalone }) => {
  const { user } = useAuth();
  const { t } = useLang();
  if (user === undefined) return <div className="panel pro-panel"><Loader2 className="spin" aria-label={t.common.loading} /></div>;
  if (!user) {
    return (
      <div className="gate-grid" data-testid={`pro-gate-${tab}`}>
        <div className="panel pro-panel gate-intro">
          <span className="s-icon" style={{ marginBottom: 18 }}><ShieldCheck aria-hidden="true" /></span>
          <h3 className="sub-title">{t.auth.gateTitle[tab]}</h3>
          <p className="pro-intro" style={{ marginTop: 12 }}>{t.auth.gateDesc[tab]}</p>
        </div>
        <AuthPanel defaultRole={tab === "client" ? "client" : "expert"} />
      </div>
    );
  }
  return (
    <div data-testid={`pro-gate-${tab}`}>
      <SignedBar showSpaceLink={!standalone && user.role !== "admin"} />
      <GateContent tab={tab} />
    </div>
  );
};
